import { wipActionTypes as Types } from '../constants';

export const chooseOrchestrationName = name => dispatch => {
  dispatch({
    type: Types.CHOOSE_ORCHESTRATION_NAME,
    payload: {
      orchestrationName: name
    }
  });
};

export const chooseAppGroup = id => dispatch => {
  dispatch({
    type: Types.CHOOSE_APP_GROUP,
    payload: {
      appGroup: id
    }
  });
};

export const chooseEntryEvent = id => dispatch => {
  dispatch({
    type: Types.CHOOSE_ENTRY_EVENT,
    payload: {
      entryEvent: id
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/wip.js